import React, { useState } from 'react';
import { Container, IndicateurEtapes, Row, Col } from '@design-system-etat/dsfr-react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ModifierArmeElementsArme from 'components/arme/ModifierArmeElementsArme';
import RoutesRatelier from '../../ratelier/routes';
import SignalerArmeManquanteEtape2 from './components/etape2/SignalerArmeManquanteEtape2';
import FinaliserArmeManquanteEtape3 from './components/etape3/FinaliserArmeManquanteEtape3';
import { getPath } from '../../../../utils/router';
import { definirComplement } from '../../../../store/titreReducer';

const SignalerArmeManquante = () => {
    const dispatch = useDispatch();
    const [etapeActive, setEtapeActive] = useState(1);
    const [dataSignalerArmeManquante, setDataSignalerArmeManquante] = useState(null);
    const history = useHistory();

    const retourRatelier = () => {
        history.push(getPath(RoutesRatelier));
    };

    const enregistrerDataSignalerArmeManquante = (armeManquante) => {
        setDataSignalerArmeManquante(armeManquante);
    };

    const setEtapeUn = () => {
        setEtapeActive(1);
    };

    const setEtapeDeux = () => {
        setEtapeActive(2);
    };

    const setEtapeTrois = () => {
        setEtapeActive(3);
    };

    const etapes = [
        { key: 1, titre: "Identification de l'arme absente" },
        { key: 2, titre: 'Récapitulatif et validation' },
        { key: 3, titre: 'Finalisation de la procédure' },
    ];

    React.useEffect(() => {
        if (etapeActive > 0) {
            dispatch(definirComplement(`étape ${etapeActive}/3`));
        }
    }, [etapeActive]);

    return (
        <Container fluid={false}>
            <Row>
                <Col col={12}>
                    <h1>Signaler une arme absente du râtelier</h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <IndicateurEtapes
                        etapeEnCours={etapeActive}
                        nombreEtapes={3}
                        titreEtapeEnCours={etapes.find((etape) => etape.key === etapeActive).titre}
                        titreProchaineEtape={
                            etapeActive < 3
                                ? etapes.find((etape) => etape.key === etapeActive + 1).titre
                                : null
                        }
                    />
                </Col>
            </Row>

            {etapeActive === 1 && (
                <ModifierArmeElementsArme
                    dataArmeElementsArme={dataSignalerArmeManquante}
                    etapePrecedente={retourRatelier}
                    enregistrerData={enregistrerDataSignalerArmeManquante}
                    etapeSuivante={setEtapeDeux}
                    modaleArmeAvant2011
                    recuperationArmeEtElementsExistant={false}
                />
            )}
            {etapeActive === 2 && (
                <SignalerArmeManquanteEtape2
                    dataSignalerArmeManquante={dataSignalerArmeManquante}
                    etapePrecedente={setEtapeUn}
                    enregistrerData={enregistrerDataSignalerArmeManquante}
                    etapeSuivante={setEtapeTrois}
                />
            )}
            {etapeActive === 3 && <FinaliserArmeManquanteEtape3 />}
        </Container>
    );
};

export default SignalerArmeManquante;
